module.exports = __webpack_public_path__ + "static/media/image_41.4a8423a6.png";